import NextLink from "next/link";

import { IcExternal } from "@jetblue/kit-icons/ic-external";

export type AuthenticatedCallToActionsProperties = {
  dataAttributePrefix?: string | undefined;
  links: {
    href: string;
    isExternal: boolean;
    label: string;
    target?: "_blank" | "_self";
  }[];
};
export const AuthenticatedCallToActions = ({
  dataAttributePrefix = "",
  links,
}: AuthenticatedCallToActionsProperties) =>
  links.length === 0 ? null : (
    <section className="border-b border-medium-gray p-6">
      {links.map((link) => (
        <NextLink
          className="flex cursor-pointer items-center text-royal-blue not-first:mt-4 not-last:mb-4 hover:text-core-blue hover:underline focus-visible:focus-outline md:not-first:mt-3 md:not-last:mb-3"
          data-fs-element={`${dataAttributePrefix}-cta-link`}
          href={link.href}
          key={link.href}
        >
          <span>{link.label}</span>

          {link.isExternal && <IcExternal className="ms-1 inline size-2" />}
        </NextLink>
      ))}
    </section>
  );
